export default __webpack_public_path__ + "static/media/phone.10115b89.svg";